import { FetchError } from '../errors/FetchError'
import { fetchApiImageAuth2, fetchWithAuthorization } from './fetch'

export const createComplaint = async (obj) => {
  try {
    const data = await fetchApiImageAuth2('/complaint', obj, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar realizar una sugerencia.')
  }
}

export const getAllComplaints = async (page = 1, limit = 10, params) => {
  const { closed, condominium, search } = params

  try {
    let url = `/complaint?condominium=${condominium}&closed=${closed}&page=${page}&limit=${limit}`
    const term = typeof search === 'string' ? search.trim() : ''
    if (term) url += `&search=${encodeURIComponent(term)}`

    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar realizar una sugerencia.')
  }
}

export const getDetailsComplaints = async (id) => {
  try {
    const data = await fetchWithAuthorization(`/complaint/${id}`)
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar realizar una sugerencia.')
  }
}

export const closeComplaints = async (params) => {
  try {
    const data = await fetchWithAuthorization(`/complaint/${params.id}`, { answer: params.answer }, 'PUT')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar realizar una sugerencia.')
  }
}
